module.exports = __webpack_public_path__ + "img/appStoreBlack.2928664f.svg";